import React from "react";
import PageHero from "./PageHero";

export const COMPANY = {
  name: "Norse3 Limited",
  address: "11 Dominion Way, Worthing, United Kingdom, BN14 8AQ",
  number: "16812462",
  email: "info@norse3.com",
};

export default function LegalPage({ eyebrow, title, updated, sections, testId }) {
  return (
    <div data-testid={testId}>
      <PageHero eyebrow={eyebrow} title={title} subtitle={`Last updated: ${updated}`} />
      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 space-y-10">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="text-base md:text-lg font-semibold text-foreground">{s.h}</h2>
              <div className="mt-3 space-y-3 text-sm sm:text-base leading-relaxed text-muted-foreground">
                {s.p.map((para) => <p key={para}>{para}</p>)}
              </div>
            </div>
          ))}
          <p className="rounded-lg border border-border p-4 text-xs text-muted-foreground" data-testid="legal-contact">
            {COMPANY.name} · Registered office: {COMPANY.address} · Registered in England and Wales, company number {COMPANY.number} · <a href={`mailto:${COMPANY.email}`} className="text-primary hover:underline">{COMPANY.email}</a>
          </p>
        </div>
      </section>
    </div>
  );
}
